import { Button, styled } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
const PrimaryButton = styled((props: ButtonProps) => <Button variant="contained" {...props} />)(({
  theme
}) => ({
  backgroundColor: '#4c403e',
  borderRadius: '20px',
  boxShadow: '0px 0px 9px 2px rgba(255, 255, 255, 0.5)',
  fontFamily: 'Montserrat, sans-serif',
  fontSize: "var(--type-h3)",
  fontWeight: 'normal',
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: "var(--type-h3)"
  },
  color: 'white',
  height: '40px',
  // NO default width - width MUST be set via sx prop to match exact requirement
  '&:hover': {
    backgroundColor: '#3a302e'
  },
  // Busy (request in flight / success shown): keep the brown fill — MUI's disabled look is grey —
  // and ignore clicks. Handlers also ignore re-entry (Enter submits).
  '&[aria-busy="true"]': {
    pointerEvents: 'none'
  }
}));
export default PrimaryButton;
